import { useCallback, useEffect, useState } from "react";
import { api, ApiRequestError } from "../api/client";

// 現在進行中の案件(ウィザード全ステップで共有)。
export interface CaseData {
  id: string;
  slug: string | null;
  status: string;
  profession: string;
  office_name: string | null;
  representative_name: string | null;
  office_phone: string | null;
  office_address: string | null;
  practice_areas: string | null;
  selected_proposal_id: string | null;
  published_url: string | null;
  updated_at: string;
}

interface State {
  caseRow: CaseData | null;
  loading: boolean;
  error: string | null;
}

export function useCurrentCase() {
  const [state, setState] = useState<State>({
    caseRow: null,
    loading: true,
    error: null,
  });

  const load = useCallback(async () => {
    try {
      const res = await api.get<{ case: CaseData | null }>("/api/cases/current");
      setState({ caseRow: res.case, loading: false, error: null });
    } catch (err) {
      setState({
        caseRow: null,
        loading: false,
        error: err instanceof ApiRequestError ? err.message : "案件の取得に失敗しました",
      });
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { ...state, reload: load };
}
